export const API_ROUTES = {
  APPLICATION_LOGO_GET: '/api/v1/application-logo_get',
  BRANCH_GET_ALL: '/api/v1/branch_get-all',
  EMAIL_CONFIRMATION_RESEND_CODE: '/api/v1/user_send-submit-email',
  EMAIL_REGISTRATION_CHECK: '/api/v1/email-registration_check',
  IS_CAPTCHA_NEEDED: '/api/v1/is-captcha-needed',
  LINK_LOGIN: '/api/v1/link-login',
  ORGANIZATION_GET_LIST: '/api/v1/organization_get-list',
  PHONE_CHECK: '/api/v1/phone_check',
  PHONE_CHECK_SMS_CODE: '/api/v1/check-sms-code-for-confirm-phone',
  PHONE_CHECK_CALL_CODE: '/api/v1/check-call-code-for-confirm-phone',
  PHONE_DEMO_SERVICE_VALIDATE_PHONE: '/api/v1/phone-demo-service_validate',
  PHONE_SEND_SMS_CODE: '/api/v1/get-message-approval-code',
  PHONE_SEND_CALL_CODE: '/api/v1/get-call-code',
  POSITION_GET_ALL: '/api/v1/post_get-all',
  POST_FIND_BY_NAME: '/api/v1/post_find-by-name',
  STUDENTS_POST_FIND_BY_NAME: '/api/v1/post_students-find-by-name',
  POSITION_GET_STUDENTS: '/api/v1/post_get-students',
  STAFF_GET_ALL: '/api/v1/staff_get-all',
  TAXATION_GET_ALL: '/api/v1/taxation_get-all',
  UNIVERSITY_GET_LIST: '/api/v1/university_get-list',
  USER_ADD: '/api/v1/user_add',
  USER_AUTH: '/api/v1/user_auth',
  USER_CHANGE: '/api/v1/user_change',
  USER_GET: '/api/v1/user_get',
  USER_RESET_PASSWORD: '/api/v1/user_reset-password',
  OAUTH_GET_CREDENTIALS: '/api/v1/oauth_get-credentials',
  RESET_PASSWORD_BY_EMAIL: '/api/v1/user-password_send-reset-email',
  RESET_PASSWORD_BY_SMS_CODE: '/api/v1/get-message-approval-code',
  RESET_PASSWORD_BY_CALL_CODE: '/api/v1/get-call-code',
  USER_UPDATE_PASSWORD: '/api/v1/auth-user-password_change',
  CHECK_RESET_SMS_CODE: '/api/v1/check-sms-code-for-reset-password',
  CHECK_RESET_CALL_CODE: '/api/v1/check-call-code-for-reset-password',
  VALIDATE_RESET_CODE: '/api/v1/user-password_validate-reset-code',
  CHANGE_USER_PASSWORD: '/api/v1/user-password_change',
  FB_AUTH: '/api/v1/oauth_start-fb',
  GP_AUTH: '/api/v1/oauth_start-gp',
  MM_AUTH: '/api/v1/oauth_start-mm',
  OK_AUTH: '/api/v1/oauth_start-ok',
  VK_AUTH: '/api/v1/oauth_start-vk',
  YA_AUTH: '/api/v1/oauth_start-ya',
}

const MAIN_PAGE = '/'
const POSITION_PAGE = '/personal/post'
const PHONE_PAGE = '/personal/phone'
const POSITION_AND_PHONE_PAGE = '/personal/postandphone'
const STAFF_PAGE = '/personal/staff'
const TAXATION_PAGE = '/personal/taxation'
const BRANCH_PAGE = '/personal/branch'
const ORGANIZATION_PAGE = '/personal/org'
const ORGANIZATION_NAME_PAGE = '/personal/company'
const AUTH_WITH_FIELD_FORM = '/personal/AuthWithFieldsForm'
const DOWNLOADING_FILE_AUTH_FORM = '/personal/DownloadingFileAuthForm'
const AUTH_WITH_BUTTONS_FORM = '/personal/AuthWithButtonsForm'
const BIRTH_DATE_PAGE = '/personal/bdate'
const LOGON_PAGE = '/Logon'
const SHORT_LOGIN_PAGE = '/account/shortlogin'
const PROFILE_PAGE = '/Personal/About'
const FEEDBACK_PAGE = '/Feedback'
const REGISTRATION_PAGE = '/Account/Registration'
const REGISTRATION_SUCCESS_PAGE = '/Registration/RegistrationSuccess'
const HELPFUL_PAGE = '/'
const FAST_LOGIN_PAGE = '/uni-link/:linkCode'
const AUTH_FROM_SOCIAL_PAGE = '/auth/FromSocial'
const CHANGE_PASSWORD_PAGE = '/Account/ChangePassword/:code'
const UPDATE_PASSWORD_PAGE = '/UpdatePassword'
const CONFIRM_EMAIL_PAGE = '/Account/ConfirmEmail'
const CONFIRM_EMAIL_ERROR_PAGE = '/Account/ConfirmEmailError'
const AGREEMENT_TERMS_OF_USE_PAGE = '/Account/Agreement'
const PERSONAL_DATA_POLICY = '/l/politika-actiond'
const AGREEMENT_DATA_PROCESSING_PAGE = '/l/soglasie_na_obrabotku'
const AGREEMENT_MAILINGS_PAGE = '/l/soglasie_na_rassilki'
const AGREEMENT_STUDENTS = '/l/agreement_students'
const LOGON_INDEX_PAGE = '/Logon/Index'
const REGISTRATION_COMPLETE_PAGE = '/Registration/RegistrationComplete'
const OUTDATED_LINK_PAGE = '/OutdatedLink'

// TODO Этот роут пока нельзя сносить, потому что етсь функционал в монолите, который задействует страницу Account/ChangePassword
const NEW_CHANGE_PASSWORD_PAGE = '/AuthGate/Account/ChangePassword/:code'

// TODO START альтернативные урлы снести после выката балансера
const NEW_REGISTRATION_SUCCESS_PAGE = '/AuthGate/Registration/RegistrationSuccess'
const NEW_AUTH_FROM_SOCIAL_PAGE = '/AuthGate/auth/fromSocial'
const NEW_CONFIRM_EMAIL_PAGE = '/AuthGate/Account/ConfirmEmail'
const AUTH_GATE_REG_PAGE = '/AuthGate/Account/Registration'
const NEW_REGISTRATION_COMPLETE_PAGE = '/AuthGate/Registration/RegistrationComplete'

const AUTH_GATE_LOGON_PAGE = '/AuthGate/Logon'
const AUTH_GATE_SHORT_LOGIN_PAGE = '/AuthGate/account/shortlogin'
const AUTH_GATE_LOGON_INDEX_PAGE = '/AuthGate/Logon/Index'
const AUTH_GATE_OUTDATED_LINK_PAGE = '/AuthGate/OutdatedLink'
// TODO END альтернативные урлы снести после выката балансера

export const ROUTES = {
  BIRTH_DATE_PAGE,
  BRANCH_PAGE,
  FAST_LOGIN_PAGE,
  LOGON_PAGE,
  MAIN_PAGE,
  ORGANIZATION_NAME_PAGE,
  ORGANIZATION_PAGE,
  PHONE_PAGE,
  POSITION_AND_PHONE_PAGE,
  POSITION_PAGE,
  REGISTRATION_PAGE,
  REGISTRATION_SUCCESS_PAGE,
  SHORT_LOGIN_PAGE,
  STAFF_PAGE,
  TAXATION_PAGE,
  AUTH_FROM_SOCIAL_PAGE,
  CHANGE_PASSWORD_PAGE,
  UPDATE_PASSWORD_PAGE,
  NEW_CHANGE_PASSWORD_PAGE,
  NEW_CONFIRM_EMAIL_PAGE,
  CONFIRM_EMAIL_PAGE,
  CONFIRM_EMAIL_ERROR_PAGE,
  AGREEMENT_TERMS_OF_USE_PAGE,
  AGREEMENT_DATA_PROCESSING_PAGE,
  AGREEMENT_STUDENTS,
  AGREEMENT_MAILINGS_PAGE,
  LOGON_INDEX_PAGE,
  NEW_REGISTRATION_SUCCESS_PAGE,
  NEW_AUTH_FROM_SOCIAL_PAGE,
  AUTH_GATE_REG_PAGE,
  NEW_REGISTRATION_COMPLETE_PAGE,
  REGISTRATION_COMPLETE_PAGE,
  OUTDATED_LINK_PAGE,
  AUTH_WITH_FIELD_FORM,
  DOWNLOADING_FILE_AUTH_FORM,
  AUTH_WITH_BUTTONS_FORM,
  AUTH_GATE_LOGON_PAGE,
  AUTH_GATE_SHORT_LOGIN_PAGE,
  AUTH_GATE_LOGON_INDEX_PAGE,
  AUTH_GATE_OUTDATED_LINK_PAGE,
  PERSONAL_DATA_POLICY,
}

export const EXTERNAL_ROUTES = {
  FEEDBACK_PAGE,
  HELPFUL_PAGE,
  PROFILE_PAGE,
}
